export default {
    day: '2023-09-23',
    content: {
        mining: [
            {
                type: 'new',
                text: 'addedFeature',
            }
        ],
        note: [
            {
                type: 'new',
                text: 'addedFeature',
            }
        ],
        gem: [
            {
                type: 'new',
                text: 'addedFeature',
            }
        ],
        village: [
            {
                type: 'new',
                text: 'addedFeature',
            }
        ],
        achievement: [
            {
                type: 'new',
                text: 'addedFeature',
            }
        ],
        school: [
            {
                type: 'new',
                text: 'addedFeature',
            }
        ],
        relic: [
            {
                type: 'new',
                text: 'addedFeature',
            }
        ],
        horde: [
            {
                type: 'new',
                text: 'addedFeature',
            }
        ],
        card: [
            {
                type: 'new',
                text: 'addedFeature',
            }
        ],
        general: [
            {
                type: 'new',
                text: 'addedFeature',
            }
        ],
        farm: [
            {
                type: 'new',
                text: 'addedFeature',
            }
        ],
        event: [
            {
                type: 'new',
                text: 'addedFeature',
            }
        ],
        treasure: [
            {
                type: 'new',
                text: 'addedFeature',
            }
        ],
        cryolab: [
            {
                type: 'new',
                text: 'addedFeature',
            }
        ],
        gallery: [
            {
                type: 'new',
                text: 'addedFeature',
            }
        ],
        mining_1: [
            {
                type: 'new',
                text: 'addedSubfeature'
            }
        ],
    }
}
